import { render, staticRenderFns } from "./unitsCard.vue?vue&type=template&id=00e44ac8&"
import script from "./unitsCard.vue?vue&type=script&lang=js&"
export * from "./unitsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports